import RequestAbstract from './abstract';

export default class Users extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/users';
    }

    async metaInfo() {
        let result = await this.get('api/users/meta-info');
        return result.data || {};
    }

    async dashboardInfo() {
        let result = await this.get("api/users/dashboard-info");
        if (result.data) {
            return result.data;
        }
        else if (result.message === 'notAuthenticated') {
            this.handleUnauthorized();
            return {};
        }
        return {};
    }

    async changePass(userId, newPass) {
        return this.post('api/users/change-pass', { userId, newPass });
    }

    async enable2FA() {
        let result = await this.get("api/users/enable-2fa");
        return result.data || {};
    }

    async disable2FA(code) {
        return this.post("api/users/disable-2fa", { code });
    }

    async activate2FA(code) {
        return this.post("api/users/enable-2fa", { code });
    }

    async updateProfile(data) {
        return this.post("api/users/update-profile", data);
    }
}
